// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2tX1E","approved":"Status_approved__33AD1","rejected":"Status_rejected__oWH4L","expired":"Status_expired__3wMHM","label":"Status_label__23vKM"};